import React from "react";
import { useIsMobile } from "@/hooks/useDisplay";
import { PageMessage } from "@picklebet/ui";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";

import { ReactComponent as WarningPending } from "assets/illustrations/warning-pending.svg";

type CheckVerifiedProps = {
  children: React.ReactNode;
  permission: string;
};

const CheckVerified = ({ children, permission }: CheckVerifiedProps) => {
  const isMobile = useIsMobile();

  if (permission === "VERIFICATION_STATUS_UNSUPPORTED") {
    return (
      <PageMessage
        title={`Verification Required`}
        image={<WarningPending />}
        subTitle={`You need to verify your account to access this page.`}
      >
        <LinkButton
          variant={`primary`}
          size={isMobile ? `md` : `default`}
          to={`/account/verification`}
        >
          Verify
        </LinkButton>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { CheckVerified };
